import { request } from '../../../../common/rest/index';

const get = (sku, locale) => {
  if (!sku || !locale) {
    throw new Error('Missing SKU or Locale when trying to fetch Prismic product.');
  }
  return request.get(
    `/api/v1/prismic/product/${sku}/${locale.toLowerCase()}`,
    null,
    {
      headers: {
        'content-type': 'application/json',
      },
    },
  );
};

export default {
  get,
};



// WEBPACK FOOTER //
// ./src/client/js/facades/prismic/product.js